export const SESSION_STORAGE_KEY_LANGUAGE = "lang";
